import { initialize } from './functions'

initialize()

export * from './firebase'
export * from './functions'
export * from './hooks'
export * from './AuthContext'
